import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// An AI assistant the parent connected by signing in (DTA-1043).
export interface McpConnection {
  id: number
  name: string
  connectedAt: string | null
  lastUsedAt: string | null
}

export interface McpConnectionsResponse {
  success: boolean
  connections: McpConnection[]
}

// GET /ajax/account_settings/mcp/connections
export const mcpConnections = async (): Promise<McpConnectionsResponse> => {
  const response = await new Request().get('/ajax/account_settings/mcp/connections')
  return Util.Obj.keysToCamel(response.data) as McpConnectionsResponse
}
